<template>
  <div class="tarifas-dashboard">
    <!-- HEADER -->
    <div class="tarifas-header">
      <div class="header-left">
        <div class="header-icon">
          <i class="lni lni-calendar"></i>
        </div>
        <div>
          <h2 class="header-title">Tarifarios</h2>
          <p class="header-subtitle">Consulta y gestiona los horarios y tarifas por temporada</p>
        </div>
      </div>
      <selectDepartment></selectDepartment>
    </div>

    <!-- BARRA DE CONTROLES -->
    <div class="controls-bar">
      <div class="controls-left">
        <div class="control-group">
          <label class="control-label">Selecciona un tarifario</label>
          <v-autocomplete v-model="tarifaType" @input="getTarifas()" placeholder="Seleccione un tarifario" outlined
            dense hide-details :items="tarifarios" item-value="value" item-text="text"
            class="control-select"></v-autocomplete>
        </div>
        <div class="control-group">
          <label class="control-label">Selecciona una temporada</label>
          <v-select outlined dense hide-details placeholder="Temporada" @input="getTarifas()" :items="temporadas"
            v-model="TemporadaSelected" item-value="id" item-text="NombreCompleto" class="control-select"></v-select>
        </div>
        <div class="control-group" v-if="tarifaType != ''">
          <label class="control-label">Filtrar por tarifa</label>
          <v-text-field v-model="searchSubcategoria" placeholder="Buscar tarifa..." outlined dense hide-details
            clearable class="control-select">
            <template v-slot:prepend-inner>
              <i class="lni lni-search-alt" style="font-size: 13px; color: #94a3b8;"></i>
            </template>
          </v-text-field>
        </div>
      </div>
      <div class="controls-right">
        <v-btn color="#3b82f6" dark outlined class="btn-add-tarifa mr-2" @click="showReplicarMasivoModal = true">
          <i class="lni lni-layers mr-2"></i> Replicar masivo
        </v-btn>
        <v-btn v-if="tarifaType != ''" @click="showHForm()" color="#10b981" dark depressed class="btn-add-tarifa">
          <i class="lni lni-plus mr-2"></i> Agregar tarifa
        </v-btn>
      </div>
    </div>

    <!-- CONTENIDO PRINCIPAL: 2 columnas -->
    <div class="main-layout">
      <!-- COLUMNA IZQUIERDA: Timeline/Gantt -->
      <div class="main-content">
        <!-- Barra de navegación de temporada -->
        <div v-if="tarifaType != '' && selectedTemporadaInfo" class="timeline-nav">
          <div class="nav-left">
            <span class="nav-range">{{ selectedTemporadaInfo.rangeLabel }}</span>
            <span v-if="selectedTemporadaInfo.nombre" class="nav-badge">
              Temporada: {{ selectedTemporadaInfo.nombre }}
            </span>
          </div>
        </div>

        <!-- Estado vacío -->
        <div v-if="tarifaType == ''" class="empty-state">
          <div class="empty-icon">
            <i class="lni lni-calendar"></i>
          </div>
          <h4>Selecciona un tarifario</h4>
          <p>Elige un tarifario del selector superior para visualizar las tarifas y horarios configurados.</p>
        </div>

        <!-- Tabla Gantt -->
        <tarifaTable v-if="tarifaType != ''" @successDelete="getTarifas" :tarifas="filteredTarifas" :bus="parentBus">
        </tarifaTable>
      </div>

      <!-- COLUMNA DERECHA: Sidebar Resumen -->
      <div class="sidebar-resumen">
        <h4 class="sidebar-title">Resumen</h4>

        <!-- Estadísticas principales -->
        <div class="stat-item">
          <div class="stat-icon" style="background: #eff6ff; color: #2563eb;">
            <i class="lni lni-calendar"></i>
          </div>
          <div class="stat-info">
            <span class="stat-number">{{ tarifarios.length }}</span>
            <span class="stat-label">Tarifarios</span>
          </div>
        </div>

        <div class="stat-item">
          <div class="stat-icon" style="background: #f0fdf4; color: #16a34a;">
            <i class="lni lni-leaf"></i>
          </div>
          <div class="stat-info">
            <span class="stat-number">{{ temporadasCount }}</span>
            <span class="stat-label">Temporadas</span>
          </div>
        </div>

        <div class="stat-item">
          <div class="stat-icon" style="background: #faf5ff; color: #7c3aed;">
            <i class="lni lni-timer"></i>
          </div>
          <div class="stat-info">
            <span class="stat-number">{{ totalHorarios }}</span>
            <span class="stat-label">Horarios activos</span>
          </div>
        </div>

        <v-divider class="my-3"></v-divider>

        <!-- Leyenda Tarifarios -->
        <h5 class="sidebar-section-title">Tarifarios</h5>
        <div v-for="tar in tarifarios" :key="tar.Id" class="legend-item clickable"
          @click="selectTarifarioFromSidebar(tar.value)">
          <span class="legend-dot" :style="{ backgroundColor: getTarifarioColor(tar) }"></span>
          <span class="legend-name" :class="{ 'active-filter': tarifaType === tar.value }">{{ tar.Nombre }}</span>
        </div>

        <v-divider class="my-3"></v-divider>

        <!-- Leyenda Temporadas -->
        <h5 class="sidebar-section-title">Temporadas</h5>
        <div v-for="temp in filteredTemporadas" :key="temp.id" class="legend-item clickable"
          @click="selectTemporadaFromSidebar(temp.id)">
          <span class="legend-dot" :style="{ backgroundColor: getTemporadaColor(temp) }"></span>
          <div class="legend-info">
            <span class="legend-name" :class="{ 'active-filter': TemporadaSelected === temp.id }">{{ temp.Nombre ||
              temp.NombreCompleto }}</span>
            <span v-if="temp.FechaInicio" class="legend-sub">{{ temp.FechaInicio }} - {{ temp.FechaTermino }}</span>
          </div>
        </div>

        <v-divider class="my-3"></v-divider>


      </div>
    </div>

    <!-- MODALES -->
    <modal v-model="showHModal" :showFooter="false" title="Agregar Temporadas y Horarios" :fullscreen="true">
      <tarifasForm :dataEdit="editData" :edit="editMode" :key="formKey" @toggle="toggleHModal" :subCate="subcategorias"
        @successDataHorario="getSuccessDataHorario" :accessArray="accessArray" :temporadas="temporadas"
        :tarifarioId="tarifaType" :tarifarios="tarifarios"></tarifasForm>
    </modal>
    <modal v-model="showReply" :showFooter="false" title="Replicar Tarifa">
      <replyTarifa :dataEdit="editData" :edit="editMode" :key="formKey" @toggle="toggleHModal" :subCate="subcategorias"
        @successDataHorario="getSuccessDataHorario" :accessArray="accessArray" :temporadas="temporadas"></replyTarifa>
    </modal>
    <!-- MODAL REPLICAR MASIVO -->
    <modal v-model="showReplicarMasivoModal" :showFooter="false" title="Replicar Tarifas" size="lg">
      <ReplicarTarifasMasivo :temporadas="temporadas" :tarifarios="tarifarios" :subcategorias="subcategorias"
        :tipos-juego="tiposJuego" :horarios="Horarios" @cancel="showReplicarMasivoModal = false; getTarifas()" />
    </modal>
  </div>
</template>

<script>
import Vue from "vue";

import tarifasForm from "./tarifasForm.vue";
import replyTarifa from "./ReplyTarifa.vue";
import modal from "../../MainComponents/modal.vue";
import tarifaTable from "../tarifaTable/tarifasTable.vue";
import TarifasClass from "../../../clases/Tarifa.js";
import ReplicarTarifasMasivo from "./ReplicarTarifasMasivo.vue";

export default {
  name: "Tarifas",
  components: {
    tarifaTable,
    tarifasForm,
    replyTarifa,
    modal,
    ReplicarTarifasMasivo,
  },
  data() {
    return {
      showReplicarMasivoModal: false,
      showReply: false,
      MainDepartamento: "",
      parentBus: new Vue(),
      showAddForm: false,
      tarifaType: "",
      temporadas: [],
      TemporadaSelected: "ALL",
      searchSubcategoria: "",
      tarifas: [],
      hoteles: [],
      subcategorias: [],
      showModal: false,
      showHModal: false,
      formKey: 1,
      formIndex: 1,
      tarifarios: [],
      tiposJuego: [],
      editData: [],
      editMode: false,
      Horarios: [],
      // Colores para asignar a tarifarios y temporadas
      tarifarioColors: ["#10b981", "#2563eb", "#7c3aed", "#d97706", "#dc2626", "#0891b2", "#059669", "#4b5563"],
      temporadaColors: ["#2563eb", "#059669", "#d97706", "#7c3aed", "#dc2626", "#0891b2", "#10b981", "#4b5563"],
    };
  },
  methods: {
    selectTarifarioFromSidebar(id) {
      this.tarifaType = id;
      this.getTarifas();
    },
    selectTemporadaFromSidebar(id) {
      this.TemporadaSelected = id;
      this.getTarifas();
    },
    getTarifarioColor(tarifario) {
      let idx = this.tarifarios.indexOf(tarifario);
      return this.tarifarioColors[idx % this.tarifarioColors.length];
    },
    getTemporadaColor(temporada) {
      let idx = this.filteredTemporadas.indexOf(temporada);
      return this.temporadaColors[idx % this.temporadaColors.length];
    },

    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/Modalidades"
      );
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });
    },

    showReplyTarifa(id) {
      this.formKey++;
      this.editMode = true;
      this.editData = this.$pgsHelper.getById(this.tarifas, "id", id);
      this.showReply = true;
    },
    showHForm() {
      this.formKey++;
      this.editMode = false;
      this.editData = {};
      this.showHModal = true;
    },
    showEditHForm(id) {
      this.formKey++;
      this.editMode = true;
      let data = this.$pgsHelper.getById(this.tarifas, "id", id)
      this.editData = this.$pgsHelper.cloneObj(data)

      this.showHModal = true;
    },

    toggleModal(open) {
      this.showModal = open;
    },
    toggleHModal(open) {
      // activa o desactiva el modal de tarifas
      this.showHModal = open;
    },
    getSuccessData(data) {
      // datos regresados por el formulario de tarifas
      let dataTarifa = {
        Nombre: data.tarifaName,
        //SubCategoria:data.subcategoria,
        Accesos: {},
        Activo: true,
      };

      if (data.aplicableAll) {
        dataTarifa.Accesos = { All: true };
      } else {
        data.accesso.forEach((element) => {
          dataTarifa.Accesos[element] = true;
        });
      }

      if (data.Id == "" || !data.Id) {
        this.saveTarifario(dataTarifa);
      } else {
        dataTarifa.Id = data.Id;
        this.editTarifario(dataTarifa);
      }
    },
    getSuccessDataHorario(data) {
      data.Accesos = data.accesos;
      data.Tarifario = this.tarifaType;
      data.Subcategoria = data.subcategoria;
      if (data.Id == "" || !data.Id || data.reply) {
        this.saveTarifa(data);
      } else {
        this.editTarifa(data);
      }
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/Horarios"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach((element) => {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getTemporadas() {
      /* obtiene el listado de temporadas activas en el sistema  */
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/Temporadas"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      const sortedTarifas = arrayTarifas
        .slice()
        .sort(
          (a, b) => new Date(b[1].FechaInicio) - new Date(a[1].FechaInicio)
        );
      this.temporadas.push({
        id: "ALL",
        NombreCompleto: "Todos",
      });
      sortedTarifas.forEach((element) => {
        this.temporadas.push({
          id: element[0],
          NombreCompleto:
            element[1].Nombre +
            " : " +
            element[1].FechaInicio +
            " - " +
            element[1].FechaTermino,
          ...element[1],
        });
      });
      this.TemporadaSelected = this.temporadas[0].id;
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Mayoristas/Coleccion"
      );
      let arrayHoteles = Object.entries(data.val());
      arrayHoteles.forEach((element) => {
        this.hoteles.push({ id: element[0], ...element[1] });
      });
    },
    async getSubcategoria() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/SubCategorias"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.$pgsHelper.log(element);
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo(
        this.MainDepartamento
      );
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },
    async getTarifas() {
      this.tarifas = [];

      /*Descarga y parseo de las tarifas segun lo selccionado*/
      let dataTarifas = await TarifasClass.getMixTarifasByTarifario(
        this.tarifaType,
        this.MainDepartamento,
        this.TemporadaSelected != "ALL" ? this.TemporadaSelected : null
      );
      dataTarifas.forEach((tarifa) => {
        tarifa.temporadaNombre = this.$pgsHelper.getById(
          this.temporadas,
          "id",
          tarifa.Temporada
        ).Nombre;
        tarifa.SubcategoriaData = [];

        tarifa.Subcategoria.forEach((subc) => {
          tarifa.SubcategoriaData.push(
            this.$pgsHelper.getById(this.subcategorias, "id", subc)
          );
        });

        tarifa.arrayPrecios.forEach((modalidad) => {
          modalidad.Nombre = this.$pgsHelper.getById(
            this.tiposJuego,
            "id",
            modalidad.id
          ).nombre;
          modalidad.horarios.forEach((horario) => {
            horario.data = this.$pgsHelper.getById(
              this.Horarios,
              "id",
              horario.id
            );
            horario.Nombre = this.$pgsHelper.getById(
              this.Horarios,
              "id",
              horario.id
            ).Nombre;
          });
        });
      });

      this.tarifas = dataTarifas;
    },
    saveTarifario(data) {
      this.$pgsHelper.log(data);
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas guardar este tarifario?",
        text: "La tarifa se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-createTarifario", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const targetId = result.value.data.data?.Id || result.value.data.id || data.Id || data.id;
            this.$pgsHelper.writeLog({
              Evento: "TARIFARIO_CREATE",
              Mensaje: `Tarifario creado: ${data.Nombre || ""}`.trim(),
              reference: { id: targetId, tp: "RVA-Tarifario", al: data.Nombre || "TARIFARIO" },
              data: data
            });
            this.$swal(
              "Tarifario Guardado",
              "El tarifario se almaceno correctamente",
              "success"
            );
            // recarga el listado de tarifarios
            this.getComboTarifarios();
            // limpiar el formulario y ocultar el modal
            this.showModal = false;
            this.formKey++;
            // marcar tarifa creada como sellecionado
            this.tarifaType = result.value.data.data.Id;
            this.getTarifas();
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editTarifario(data) {
      this.$pgsHelper.log(data);
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas guardar este tarifario?",
        text: "La tarifa se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-updateTarifario", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const targetId = result.value.data.data?.Id || result.value.data.id || data.Id || data.id;
            this.$pgsHelper.writeLog({
              Evento: "TARIFARIO_EDIT",
              Mensaje: `Tarifario editado: ${data.Nombre || ""}`.trim(),
              reference: { id: targetId, tp: "RVA-Tarifario", al: data.Nombre || "TARIFARIO" },
              data: data
            });
            this.$swal(
              "Tarifario Guardado",
              "El tarifario se almaceno correctamente",
              "success"
            );
            // recarga el listado de tarifarios
            this.getComboTarifarios();
            // limpiar el formulario y ocultar el modal
            this.showModal = false;
            this.formKey++;
            // marcar tarifa creada como sellecionado
            this.tarifaType = result.value.data.data.Id;
            this.getTarifas();
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    saveTarifa(data) {
      data.Departamento = this.MainDepartamento;
      this.$swal({
        title: "Deseas guardar esta tarifa para este tarifario?",
        text: "La tarifa se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //var addTarifa = this.$store.getters.getFirebaseApp.fba.call('Golf-Tarifas-crearPrecioTarifa');
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-createTarifa", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const tempObj = this.$pgsHelper.getById(this.temporadas, "id", data.Temporada);
            const subCatId = Array.isArray(data.Subcategoria) ? data.Subcategoria[0] : (data.Subcategoria || data.cateTarifa);
            const subCatObj = this.$pgsHelper.getById(this.subcategorias, "id", subCatId);
            const nombreTarifa = data.Nombre || [tempObj?.Nombre, subCatObj?.Nombre].filter(Boolean).join(" - ") || "Tarifa Golf";
            const targetId = result.value.data.data?.Id || result.value.data.id || data.Id || data.id;

            this.$pgsHelper.writeLog({
              Evento: "TARIFA_CREATE",
              Mensaje: `Tarifa creada: ${nombreTarifa}`.trim(),
              reference: { id: targetId, tp: "RVA-Tarifa", al: nombreTarifa },
              data: data
            });

            this.$swal(
              "Tarifa Guardado",
              "La tarifa se almaceno correctamente",
              "success"
            );
            //racargado de tarifas y limpieza de formularios
            this.getTarifas();
            //limpieza de formulario y modal
            this.showHModal = false;
            this.showReply = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editTarifa(data) {
      data.Departamento = this.MainDepartamento;
      this.$swal({
        title: "Deseas guardar la modificación de esta tarifa",
        text: "La tarifa se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-updateTarifa", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const tempObj = this.$pgsHelper.getById(this.temporadas, "id", data.Temporada);
            const subCatId = Array.isArray(data.Subcategoria) ? data.Subcategoria[0] : (data.Subcategoria || data.cateTarifa);
            const subCatObj = this.$pgsHelper.getById(this.subcategorias, "id", subCatId);
            const nombreTarifa = data.Nombre || [tempObj?.Nombre, subCatObj?.Nombre].filter(Boolean).join(" - ") || "Tarifa Golf";
            const targetId = result.value.data.data?.Id || result.value.data.id || data.Id || data.id;

            this.$pgsHelper.writeLog({
              Evento: "TARIFA_EDIT",
              Mensaje: `Tarifa editada: ${nombreTarifa}`.trim(),
              reference: { id: targetId, tp: "RVA-Tarifa", al: nombreTarifa },
              data: data
            });

            this.$swal(
              "Tarifa Guardada",
              "La tarifa se almaceno correctamente",
              "success"
            );
            //racargado de tarifas y limpieza de formularios
            this.getTarifas();
            //limpieza de formulario y modal
            this.showHModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    busEvents() {
      this.parentBus.$on("refreshList", this.getTarifas);
      this.parentBus.$on("editTarifa", this.showEditHForm);
      this.parentBus.$on("replyTarifa", this.showReplyTarifa);
    },
  },
  watch: {
    // el listener de Firestore actualiza el store despues de guardar, se recarga la lista cuando llega el cambio
    rvaTarifasStore() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => {
        if (this.tarifaType) this.getTarifas();
      }, 300);
    },
  },
  computed: {
    rvaTarifasStore() {
      return this.$store.getters["dataLists/getRVATarifas"];
    },
    temporadasCount() {
      return this.temporadas.filter((t) => t.id !== "ALL").length;
    },
    totalHorarios() {
      return this.Horarios.length;
    },
    filteredTemporadas() {
      return this.temporadas.filter((t) => t.id !== "ALL");
    },
    selectedTemporadaInfo() {
      if (this.TemporadaSelected === "ALL") {
        return { rangeLabel: "Todas las temporadas", nombre: "" };
      }
      let temp = this.temporadas.find((t) => t.id === this.TemporadaSelected);
      if (!temp) return null;
      return {
        rangeLabel: (temp.FechaInicio || "") + " — " + (temp.FechaTermino || ""),
        nombre: temp.Nombre || "",
      };
    },
    accessArray() {
      let access = [
        {
          name: "Campo de golf",
          id: "SELF",
          key: "SELF",
          text: "Campo de golf",
          value: "SELF",
        },
      ];

      this.hoteles.forEach((element) => {
        access.push({
          code: element.Codigo,
          name: element.Nombre,
          id: element.id,
          key: element.id,
          text: element.Nombre,
          value: element.id,
        });
      });

      return access;
    },
    tarifasData() {
      let arrayTarifas = [];
      this.tarifas.forEach((element) => {
        let addonIndex = this.$_.findIndex(this.accessArray, [
          "code",
          !Array.isArray(element.Accesos[0])
            ? element.Accesos[0]
            : element.Accesos[0][0],
        ]);
        this.$pgsHelper.log(addonIndex);
        element.accessoData =
          addonIndex >= 0
            ? this.accessArray[addonIndex]
            : element.Accesos[0] == "Global"
              ? { id: "Global", name: "Tarifa Global", code: "Global" }
              : { id: "Web", name: "Tarifa Web", code: "Web" };
        arrayTarifas.push(element);
      });

      return arrayTarifas;
    },
    filteredTarifas() {
      if (!this.searchSubcategoria || !this.searchSubcategoria.trim()) {
        return this.tarifas;
      }
      const term = this.searchSubcategoria.trim().toLowerCase();
      return this.tarifas.filter((t) => {
        const subTexto = (t.SubcategoriaData && t.SubcategoriaData.length)
          ? t.SubcategoriaData.map((s) => s.text).join(", ")
          : "Sin subcategoría";
        return subTexto.toLowerCase().includes(term);
      });
    },
  },
  beforeMount() {
    this.$store.dispatch("TarifasStore/getMercadosReserva");
    this.getTemporadas();
    this.getSubcategoria();
    this.getHoteles();
    this.getTiposJuego();
    this.getHorarios();
  },
  mounted() { },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.busEvents();
    this.getComboTarifarios();
  },
};
</script>

<style scoped>
.tarifas-dashboard {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

/* ─── HEADER ─── */
.tarifas-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

.header-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
}

.header-subtitle {
  margin: 0;
  font-size: 0.82rem;
  color: #64748b;
}

/* ─── BARRA DE CONTROLES ─── */
.controls-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  gap: 1rem;
  flex-wrap: wrap;
}

.controls-left {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 200px;
  max-width: 280px;
  flex: 1;
}

.control-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.controls-right {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}

.btn-add-tarifa {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
  padding: 0 1.25rem !important;
  height: 40px !important;
}

/* ─── LAYOUT PRINCIPAL ─── */
.main-layout {
  display: grid;
  grid-template-columns: 1fr 260px;
  background: #ffffff;
  min-height: 350px;
}

@media (max-width: 960px) {
  .main-layout {
    grid-template-columns: 1fr;
  }
}

/* ─── CONTENIDO PRINCIPAL ─── */
.main-content {
  padding: 0;
  overflow-x: auto;
  overflow-y: auto;
  min-height: 300px;
  max-height: 70vh;
}

.timeline-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.nav-range {
  font-weight: 600;
  font-size: 0.9rem;
  color: #1e293b;
}

.nav-badge {
  background: #e0f2fe;
  color: #0369a1;
  padding: 0.2rem 0.65rem;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 600;
}

/* ─── ESTADO VACÍO ─── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: #94a3b8;
}

.empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: #94a3b8;
  margin-bottom: 1rem;
}

.empty-state h4 {
  color: #475569;
  margin-bottom: 0.5rem;
}

.empty-state p {
  max-width: 340px;
  font-size: 0.85rem;
  line-height: 1.5;
}

/* ─── SIDEBAR RESUMEN ─── */
.sidebar-resumen {
  padding: 1.25rem;
  border-left: 1px solid #e2e8f0;
  background: #fafbfc;
  overflow-y: auto;
  max-height: 70vh;
}

.sidebar-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 1rem 0;
}

.sidebar-section-title {
  font-size: 0.78rem;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin: 0 0 0.6rem 0;
}

/* Estadísticas */
.stat-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.stat-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 1.2rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.1;
}

.stat-label {
  font-size: 0.72rem;
  color: #64748b;
}

/* Leyendas */
.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.55rem;
  padding: 4px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.legend-item.clickable {
  cursor: pointer;
}

.legend-item.clickable:hover {
  background-color: #f1f5f9;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-info {
  display: flex;
  flex-direction: column;
}

.legend-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
  line-height: 1.2;
  transition: color 0.2s ease;
}

.legend-name.active-filter {
  color: #0f172a;
  font-weight: 800;
}

.legend-sub {
  font-size: 0.68rem;
  color: #94a3b8;
}

/* Tip */
.sidebar-tip {
  display: flex;
  gap: 0.6rem;
  padding: 0.75rem;
  background: #f0fdf4;
  border-radius: 8px;
  border: 1px solid #bbf7d0;
}

.tip-icon {
  color: #16a34a;
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.tip-text {
  font-size: 0.75rem;
  color: #15803d;
  line-height: 1.4;
}

.tip-text strong {
  display: block;
  margin-bottom: 2px;
}

.tip-text p {
  margin: 0;
}
</style>
